import axios from "axios";

export const apiInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

apiInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  const language = localStorage.getItem("language");
  if (token) {
    config.headers.set("Authorization", `Bearer ${token}`);
    config.headers.set("Access-Control-Allow-Credentials", "true");
    config.headers.set("user-lang", language);
  }

  return config;
});

apiInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // if (error.response?.status === 401) {
    if (error.status === 401) {
      // apiInstance
      //   .put(
      //     new URL(
      //       `${process.env.REACT_APP_API_URL}/v1/auth/refresh-toke`,
      //     ).toString(),
      //     { refreshToken: localStorage.getItem("refreshToken") },
      //   )
      //   .then((response) => {
      //     localStorage.setItem("token", response.data.accessToken);
      //   })
      //   .catch(() => {
      //     localStorage.removeItem("token");
      //     window.location.reload();
      //   });
      localStorage.removeItem("token");
      window.location.href = "/";
    }
    return Promise.reject(error);
  },
);
